<script setup lang="ts">
import DocumentOverviewTable from '@/pages/investors/documents/DocumentOverviewTable.vue'
import DocumentUploadCard from '@/pages/investors/documents/DocumentUploadCard.vue'
import { Head } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'
import DocumentOverviewData = App.Data.Documents.DocumentOverviewData

defineProps<{
  overview: DocumentOverviewData
}>()

const { t } = useI18n()
</script>

<template>
  <Head :title="t('heading')" />

  <div class="mb-6">
    <p class="section-label">{{ t('eyebrow') }}</p>
    <div class="flex items-center gap-2">
      <h1 class="page-title">{{ t('heading') }}</h1>
      <PageTitleHelp :text="t('subtitle')" />
    </div>
  </div>

  <div class="flex flex-col gap-6">
    <DocumentUploadCard :upload-areas="overview.uploadAreas" />
    <DocumentOverviewTable :rows="overview.rows" :upload-areas="overview.uploadAreas" />
  </div>
</template>

<i18n lang="json">
{
  "de": {
    "eyebrow": "Tools",
    "heading": "Dokumente",
    "subtitle": "Alle Unterlagen zu deiner Person, deinen Unternehmen und deinen Immobilien an einem Ort."
  },
  "en": {
    "eyebrow": "Tools",
    "heading": "Documents",
    "subtitle": "All documents about you, your companies and your properties in one place."
  }
}
</i18n>
